import { inject, Injectable } from '@angular/core';

import { SessionSettingsService } from 'app/shared/services/session-settings.service';

export interface Redirect {
  url: string[];
  params?: any[];
};

@Injectable({
  providedIn: 'root'
})
export class GoogleImportSessionSettingsService {
  private readonly sessionSettingsService = inject(SessionSettingsService);

  public readonly googleClassroomImport = 'GoogleClassroomImport';
  public readonly googleClassroomStudentImport = 'GoogleClassroomStudentImport';
  private readonly pendingImportKey = 'GoogleClassroom.PendingImport';
  private readonly oauthProcessKey = 'OAuth.Process';
  private readonly oauthRedirectKey = 'OAuth.Redirect';
  private readonly oauthRedirectParamsKey = 'OAuth.RedirectParams';

  public isPendingImport(): boolean {
    return this.sessionSettingsService.get(this.pendingImportKey) === '1';
  }

  public setPendingImport(): void {
    this.sessionSettingsService.set(this.pendingImportKey, '1');
  }

  public resetPendingImport(): void {
    this.sessionSettingsService.set(this.pendingImportKey, '0');
  }

  public setProcess(key: string): void {
    this.sessionSettingsService.set(this.oauthProcessKey, key);
  }

  public clearProcess(): void {
    this.sessionSettingsService.set(this.oauthProcessKey, null);
  }

  public getProcess(): string | null {
    return this.sessionSettingsService.get(this.oauthProcessKey);
  }

  public setRedirect(redirect: Redirect): void {
    this.sessionSettingsService.set(this.oauthRedirectKey, redirect.url);
    if (redirect.params) {
      this.sessionSettingsService.set(this.oauthRedirectParamsKey, redirect.params);
    }
  }

  public getRedirect(): Redirect | null {
    const url = this.sessionSettingsService.get(this.oauthRedirectKey);
    if (!url) {
      return null;
    }
    const params = this.sessionSettingsService.get(this.oauthRedirectParamsKey);
    return { url: url, params: params };
  }

  public clearRedirect(): void {
    this.sessionSettingsService.set(this.oauthRedirectKey, null);
    this.sessionSettingsService.set(this.oauthRedirectParamsKey, null);
  }
}
